<template>
  <section v-if="numberOfItems" data-cy="straplines">
    <p
      v-for="(block, url, index) in visibleItems"
      :key="url + '-' + block.straplineContent.language"
      :data-cy="'strapline-' + index"
      class="bg-primary-500 flex items-center justify-center text-xs tracking-widest text-center px-4 py-3"
      :style="{ 'background-color': block.backgroundColor }"
    >
      <html-textarea :value="block.straplineContent.value" data-cy="input"></html-textarea>
    </p>
  </section>
  <!-- <div class="bg-primary text-white flex items-center justify-center">
    <p class="uppercase text-xs tracking-widest text-center px-4 py-3">
      livraison offerte en point relais mondial relay en france métropolitaine
    </p>
  </div> -->
</template>

<script lang="ts" src="./strap-line.component.ts" />
